/** Design tokens e ativos compartilhados (Stitch / Madri Lab — Gepetto Cursos). */

export const ATM_FH = "font-['Manrope',system-ui,sans-serif]";

/** Largura máxima única do conteúdo (perfil, planos, colab, logs, indique). Fluido até ~1240px. */
export const ATM_PAGE_MAX_CLASS = 'mx-auto w-full max-w-[1240px]';

export const ATM_ACTIVE_USER_AVATAR =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuClExMtJ89QSv3Vktwvs0L5-YBzRFEGikY-QXbucZmq0GpzpwjHSVYXQ5YUlCVrGrsZ06a6dGOaCQtpu32maiBW_f3dWMeDoqXVBxfwHOVTk0Ewmd9hWhJInJT0c3s0itlZKAxYLRBtfFpvrulTN3UXNa1IwrRvDp8bu-eWgKWc23UfzZS7dSnml4zEuvfJi0ZUDjODFOpofBd3gUdWIBdfq_HpiW1AMBLFaJbf0m8dlJ4rZDziMczfC0b9LaR_NS92JlK9QpoyJSk';
